<script setup lang="ts">
import { formatFileSize } from '@/tools/format';
import type { PendingAttachment } from '@/composables/useAttachments';

defineProps<{
  items: PendingAttachment[];
  disabled?: boolean;
}>();

const emit = defineEmits<{
  remove: [key: number];
}>();
</script>

<template>
  <ul
    v-if="items.length"
    class="chips"
  >
    <li
      v-for="item in items"
      :key="item.key"
      class="chip"
      data-testid="widget-attachment-chip"
    >
      <span class="chip__name">{{ item.file.name }}</span>
      <span class="chip__size">{{ formatFileSize(item.file.size) }}</span>
      <button
        type="button"
        class="chip__remove"
        :aria-label="`Remove ${item.file.name}`"
        :disabled="disabled"
        data-testid="widget-attachment-remove"
        @click="emit('remove', item.key)"
      >
        ×
      </button>
    </li>
  </ul>
</template>

<style scoped>
.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.chip {
  display: flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  padding: 3px 4px 3px 10px;
  border: 1px solid var(--w-border);
  border-radius: 999px;
  background: var(--w-bg-subtle);
  font-size: 12px;
}

.chip__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chip__size {
  flex: none;
  color: var(--w-text-muted);
}

.chip__remove {
  flex: none;
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: var(--w-text-muted);
  font-size: 15px;
  line-height: 1;
}

.chip__remove:hover:not(:disabled) {
  background: var(--w-border);
  color: var(--w-text);
}
</style>
